import {
  SET_ACTIVE_USERS,
  SET_ALL_USERS,
  SET_AT_RISK_USERS,
  SET_INACTIVE_USERS,
  SET_NEW_USERS,
  SET_USER_VIEWS,
} from "../actionType";

const setAllUsersData = (data) => {
  return {
    type: SET_ALL_USERS,
    payload: data,
  };
};

const setActiveUsersData = (data) => {
  return {
    type: SET_ACTIVE_USERS,
    payload: data,
  };
};

const setInactiveUsersData = (data) => {
  return {
    type: SET_INACTIVE_USERS,
    payload: data,
  };
};

const setAtRiskUsersData = (data) => {
  return {
    type: SET_AT_RISK_USERS,
    payload: data,
  };
};

const setNewUsersData = (data) => {
  return {
    type: SET_NEW_USERS,
    payload: data,
  };
};

const setUserViewsData = (data) => {
  return {
    type: SET_USER_VIEWS,
    payload: data,
  };
};

export {
  setActiveUsersData,
  setAllUsersData,
  setAtRiskUsersData,
  setInactiveUsersData,
  setNewUsersData,
  setUserViewsData,
};
